

const LeftSection:React.FC = () => {
    return (
        <div className="
        w-full
        lg:w-[30%]">
            <div className="font-bold uppercase">
                <p className="
                text-[70px]
                lg:text-[100px]
                ">word</p>
                <div className="flex items-end mt-[-20px]">
                    <p className="
                    text-[35px]
                    lg:text-[50px]
                    ">about</p>
                    <p className="leading-10
                    text-[80px]
                    lg:text-[110px]
                    ">us</p>
                </div>
                <p className="text-violet-800  leading-none mt-[-8px] line-through
                text-[22px]
                lg:text-[30px]
                ">avirbhavks</p>
            </div>
            <div className="text-justify tracking-tight mt-10 text--font text-sm text-slate-500">
                <p className=" mb-2">Established in 2024, <span className="text--highlight">Avirbhaavks</span> sets sail with a visionary mission: to pioneer transformative solutions that bridge the gap between dreams and reality, igniting a new era of possibility.</p>
                <p className=" mb-2">Their inaugural triumph stems from the <span className="text--highlight">"Tomato Grand Challenge"</span>, endorsed by the Indian government, leaving researchers and innovators across the nation awestruck with its groundbreaking solutions.</p>
            </div> 
        </div>
    );
}
 
export default LeftSection;